var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChooseWalletArrowFillIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 49,
    height: 44,
    rx: 4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.05 26.17V20.41L32.042 23.29L27.05 26.17ZM28.906 22.49V24.09H16.858V22.49H28.906Z",
    fill: "#E6F2FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseWalletArrowFillIcon);
export default __webpack_public_path__ + "static/media/choose-wallet-arrow-fill-icon.aa2e8f2ace9b21fcdc8840c38c76e75f.svg";
export { ForwardRef as ReactComponent };